module.exports = "<div class=\"back-to-dashboard d-flex align-items-center\" ng-if=\"ctrl.canNavigateBack()\" ng-class=\"{'back-to-dashboard-fixed': ctrl.fixed}\">\n    <div class=\"clickable d-flex align-items-center ml16\" ng-click=\"ctrl.goBackLink()\">\n        <span class=\"arrow mr16\"></span>\n        <div class=\"title\" translate=\"back_to_dashboard\"></div>\n    </div>\n</div>\n\n<div class=\"fake-block\" ng-if=\"ctrl.canNavigateBack() && ctrl.fixed\"></div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app.common/modules/common/components/back-to-dashboard/back-to-dashboard.component.html
// module id = 623
// module chunks = 6